import { ReactElement, ReactNode, useId } from 'react';

import styles from './MedicaidHistoryModal.module.scss';

interface IPlanFieldProps {
  label: string;
  children: ReactNode;
}

const PlanField = ({ label, children }: IPlanFieldProps): ReactElement => {
  const labelId = useId();

  return (
    <div role="group" aria-labelledby={labelId} className={styles.field}>
      <span id={labelId} className={styles.label}>
        {label}
      </span>
      <span className={styles.value}>{children}</span>
    </div>
  );
};

export default PlanField;
